export default __webpack_public_path__ + "static/media/make6.41911f2e.png";